import { COUNTRIES } from '../currencies';
import { currencyUi } from '../data';

// Street, postcode and country — asked only when the donation is in a foreign
// currency.
//
// This is not a nicety. IsraelGives' page makes an address mandatory for
// EUR/GBP/CAD (`AdressIsMandatory()`), and in a POSTed flow every donor input
// on their side is hidden (class `postHide`), so a field we don't fill is one
// the donor CANNOT fill — the charge just refuses to go through, inside an
// iframe, with nothing on screen to explain it. Asking here is what makes a
// non-shekel donation completable at all.
//
// `setField` and `errors` are the page's own — these render inside the existing
// donor form and behave exactly like the fields around them.
//
// `includeStreet` is off for the membership page, whose form already asks for a
// street address in every currency; there, only the postcode and country are
// missing.
export default function ForeignAddressFields({ form, errors, setField, includeStreet = true }) {
  return (
    <>
      <div className="mf-row">
        {includeStreet && (
          <label className="mf-field">
            <span className="mf-label">
              {currencyUi.fields.street.he} {currencyUi.fields.street.ar} <em>*</em>
            </span>
            <input
              autoComplete="street-address"
              className={errors.street ? 'mf-invalid' : undefined}
              value={form.street || ''}
              onChange={setField('street')}
            />
            {errors.street && <span className="mf-error">{errors.street}</span>}
          </label>
        )}
        <label className="mf-field">
          <span className="mf-label">
            {currencyUi.fields.zipCode.he} {currencyUi.fields.zipCode.ar} <em>*</em>
          </span>
          <input
            autoComplete="postal-code"
            /* IsraelGives' own postcode input is maxlength=7; matching it here
               means a donor sees what will actually be sent, rather than typing
               a ZIP+4 that gets silently clipped on their side. */
            maxLength={7}
            className={errors.zipCode ? 'mf-invalid' : undefined}
            value={form.zipCode || ''}
            onChange={setField('zipCode')}
          />
          {errors.zipCode && <span className="mf-error">{errors.zipCode}</span>}
        </label>
      </div>
      <label className="mf-field">
        <span className="mf-label">
          {currencyUi.fields.country.he} {currencyUi.fields.country.ar} <em>*</em>
        </span>
        <select
          autoComplete="country"
          className={`mf-select${errors.countryId ? ' mf-invalid' : ''}`}
          value={form.countryId || ''}
          onChange={setField('countryId')}
        >
          <option value="">—</option>
          {COUNTRIES.map((c) => (
            <option key={c.id} value={c.id}>{c.en}</option>
          ))}
        </select>
        {errors.countryId && <span className="mf-error">{errors.countryId}</span>}
      </label>
    </>
  );
}
